import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api/axios";
import ReceiptTemplate from "./ReceiptTemplate";

const ReceiptPage = () => {
  const { id } = useParams();
  const receiptRef = useRef();
  const [receiptData, setReceiptData] = useState(null);

  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const res = await api.get(`receipts/${id}`);
        setReceiptData(res.data);
      } catch (error) {
        console.error("Error fetching receipt:", error);
      }
    };

    fetchReceipt();
  }, [id]);

  const downloadPDF = async () => {
    if (!receiptRef.current) return;

    const canvas = await html2canvas(receiptRef.current, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const imgWidth = 210; // A4 width in mm
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    pdf.save(`Receipt-${receiptData?.receipt_number}.pdf`);
  };

  if (!receiptData) return <div>Loading receipt...</div>;

  return (
    <div>
      <ReceiptTemplate ref={receiptRef} data={receiptData} />

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button
          onClick={downloadPDF}
          style={{
            background: "#0d6efd",
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Download PDF
        </button>
      </div>
    </div>
  );
};

export default ReceiptPage;
